<div
  #dropTarget
  class="drop-target"
  (dragenter)="dragEnter($event)"
  (dragover)="dragEnter($event)"
  (dragleave)="dragLeave($event)"
  (drop)="fileDropped($event); dragLeave($event)"
>
  <div class="drag-overlay">
    <div class="drag-message">
      <mat-icon>library_add</mat-icon>
      <br />
      {{ 'GALAXY.UPLOADER.DRAG_AND_DROP_PL' | translate }}
    </div>
  </div>
  <ng-content></ng-content>
</div>
